import React, {Component} from 'react';
import MainContent from './MainContent';

class Layout extends Component{
    render(){

        /**let LayoutComponent = <div className="loading"></div>;
        if(!this.props.userValidated){
            LayoutComponent = <PasswordForm {...this.props} />
        }else{
            if ( this.props.apiData.hasOwnProperty('take_up') ) {
                LayoutComponent = <MainContent {...this.props} />
            }
        }
        
        to add Password back in --- replace <MinContent {...this.props} /> with {LayoutComponent} 


        OLD site-wrapper content - removed header & footer due to clashes
                <Header />
                <Breadcrumbs />
                <MainContent {...this.props} />
                <Footer />


        **/

        return(
            <div className="site-wrapper">
                <MainContent {...this.props} /> 
            </div>
        )
    }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/js/components/layout/Layout.js